import { Card, Grid, makeStyles } from "@material-ui/core";
import { TabGeneric } from "../../compartidos/genericos/menu/TabGeneric";
import { AbmTiposReclamos } from "./AbmTiposReclamos";
import { AbmOrigenesReclamos } from "./AbmOrigenesReclamos";
import { AbmCategoriasReclamos } from "./AbmCategoriasReclamos";
import { useSelector } from "react-redux";
import { AREAS_FISICAS } from "../../../utils/constants";

const useStyles = makeStyles({
  root: {
    marginTop: "1rem",
  },
});

export const MenuGestionReclamos = () => {
  const classes = useStyles();
  const { areasFisicasUsuario } = useSelector((state) => state.auth);

  return (
    <div className={classes.root}>
      {areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES && (
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} md={9}>
            <Card>
              <TabGeneric
                tabs={[
                  {
                    name: "Tipos de reclamos",
                    component: <AbmTiposReclamos />,
                  },
                  {
                    name: "Origen de reclamos",
                    component: <AbmOrigenesReclamos />,
                  },
                  {
                    name: "Categorías de reclamo",
                    component: <AbmCategoriasReclamos />,
                  },
                ]}
              />
            </Card>
          </Grid>
        </Grid>
      )}
    </div>
  );
};
